import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Escuta o clique do push fora do shell autenticado. Se a aba estiver no login,
 * o navigate cai no ProtectedRoute, que guarda o destino e devolve depois da entrada.
 */
export function PushNavigateListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      const data = event.data as { type?: string; path?: string } | null;
      if (data?.type === 'PUSH_NAVIGATE' && data.path?.startsWith('/')) {
        navigate(data.path);
      }
    };
    navigator.serviceWorker?.addEventListener('message', onMessage);
    return () => navigator.serviceWorker?.removeEventListener('message', onMessage);
  }, [navigate]);

  return null;
}
